import BaseModel from './BaseModel';

class RecipientFilterOption extends BaseModel {}

RecipientFilterOption.collection = 'RecipientFilterOptions';

export default RecipientFilterOption;
